import React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'

const GetDefaults = () => {
	const { favicon, site } = useStaticQuery(graphql`
		query getDefaults {
			favicon: datoCmsFaviconMetaTags {
				tags
			}
			site: datoCmsSite {
				noIndex
				globalSeo {
					facebookPageUrl
					siteName
					titleSuffix
					twitterAccount
					fallbackSeo {
						description
						image {
							url
						}
						title
						twitterCard
					}
				}
			}
		}
	`)

	return {
		...favicon,
		...site,
	}
}

interface MetaProps {
	seo?: {
		title?: string
		description?: string
		image?: {
			url: string
		}
		twitterCard?: string
	}
}

interface SeoTag {
	tagName: string
	attributes: {
		href: string
		rel: string
		sizes: string
	}
}

const Meta = ({ seo }: MetaProps) => {
	const defaults = GetDefaults()

	const title = seo?.title
		? `${seo?.title}${defaults?.globalSeo?.titleSuffix}`
		: `${defaults?.globalSeo?.siteName}`
	const description =
		seo?.description ?? defaults?.globalSeo?.fallBack?.description
	const image = (
		seo?.image?.url ?? defaults?.globalSeo?.fallbackSeo?.image?.url
	).split(`?`)[0]
	const cardType =
		seo?.twitterCard ?? defaults?.globalSeo?.fallbackSeo?.twitterCard
	// console.log({ title, description, image, cardType })
	return (
		<Helmet>
			<title>{title}</title>
			<meta name="description" content={description} />

			<meta property="og:title" content={title} />
			<meta property="og:description" content={description} />
			<meta property="og:image" content={image} />
			<meta
				property="og:url"
				content={
					defaults?.siteMeta?.siteMetaData?.siteUrl || `https://evercoreheroes.com`
				}
			/>
			<meta property="og:type" content="website" />

			<meta name="twitter:title" content={title} />
			<meta name="twitter:description" content={description} />
			<meta name="twitter:image" content={image} />
			<meta name="twitter:card" content={cardType} />

			{defaults?.noIndex && <meta name="robots" content="noindex" />}

			{defaults?.tags?.map(
				({ tagName, attributes }: SeoTag, i: string) =>
					tagName === `link` && (
						<link
							key={i}
							href={attributes?.href}
							rel={attributes?.rel}
							sizes={attributes?.sizes}
						/>
					)
			)}
		</Helmet>
	)
}

export default Meta
